<template>
  <div class="page-container bg-color-default">
    <van-nav-bar
      left-arrow
      fixed
      title="我的理财"
      @click-left="$router.replace({ path: '/user' })"
      :z-index="10"></van-nav-bar>

    <!-- ------------------------new start------------------------ -->
    <div class="invest-log fy">
      <van-tabs v-model="tab.active" swipeable animated sticky offset-top="45">
        <!-- 持有中 -->
        <van-tab title="持有中" name="applying">
          <van-list
            class="applying"
            v-model="applyingList.loading"
            :immediate-check="false"
            :finished="applyingList.finished"
            :finished-text="applyingList.finishedText"
            @load="onLoadApplying">
            <div class="holding" v-for="(n, i) of applyingList.data" :key="i">
              <router-link
                class="holding-box"
                @click.native="saveTab"
                :to="{
                  name: 'subscribe',
                  params: { id: n.id, status: 2 }
                }">
                <!-- top -->
                <van-cell class="top" :value="n.name">
                  <van-icon slot="right-icon" name="arrow" />
                </van-cell>

                <!-- down -->
                <div class="down">
                  <div class="down-left">
                    <div class="title">收益到期日</div>
                    <div class="num">
                      {{ dateFormat(n.endTime, "YYYY/MM/DD") }}
                    </div>
                  </div>

                  <div class="down-center">
                    <div class="title">预期回款(元)</div>
                    <div class="num future">
                      {{ numFormat(n.returnAmount) }}
                    </div>
                  </div>

                  <div class="down-right">
                    <div class="title">认购总额(元)</div>
                    <div class="num">{{ numFormat(n.amount) }}</div>
                  </div>
                </div>
              </router-link>
            </div>
            <!-- 无数据，显示空 -->
            <van-empty
              description="暂无记录"
              v-if="applyingList.isEmpty && !applyingList.loading">
              <van-button
                round
                type="danger"
                class="bottom-button"
                @click="investClick"
                >立即投资</van-button
              >
            </van-empty>
          </van-list>
        </van-tab>
        <!-- 申请中 -->
        <van-tab title="申请中" name="possession">
          <van-list
            class="possession"
            v-model="possessionList.loading"
            :immediate-check="false"
            :finished="possessionList.finished"
            :finished-text="possessionList.finishedText"
            @load="onLoadPossession">
            <div class="holding" v-for="(n, i) of possessionList.data" :key="i">
              <router-link
                class="holding-box fy"
                @click.native="saveTab"
                :to="{
                  name: 'subscribe',
                  params: { id: n.id, status: 1 }
                }">
                <!-- top -->
                <van-cell class="top" :value="n.name">
                  <van-icon slot="right-icon" name="arrow" />
                </van-cell>

                <!-- down -->
                <div class="down">
                  <div class="down-left">
                    <div class="title">收益起算日</div>
                    <div class="num">
                      {{ dateFormat(n.beginTime, "YYYY/MM/DD") }}
                    </div>
                  </div>

                  <div class="down-center">
                    <div class="title">预期收益(元)</div>
                    <div class="num future">
                      {{ numFormat(n.returnAmount) }}
                    </div>
                  </div>

                  <div class="down-right">
                    <div class="title">认购总额(元)</div>
                    <div class="num">{{ numFormat(n.amount) }}</div>
                  </div>
                </div>
              </router-link>
            </div>
            <!-- 无数据，显示空 -->
            <van-empty
              description="暂无记录"
              v-if="possessionList.isEmpty && !possessionList.loading">
              <van-button
                round
                type="danger"
                class="bottom-button"
                @click="investClick"
                >立即投资</van-button
              >
            </van-empty>
          </van-list>
        </van-tab>
        <!-- 已结清 -->
        <van-tab title="已结清" name="cleared">
          <van-list
            class="cleared"
            v-model="clearedList.loading"
            :immediate-check="false"
            :finished="clearedList.finished"
            :finished-text="clearedList.finishedText"
            @load="onLoadCleared">
            <div class="holding" v-for="(n, i) of clearedList.data" :key="i">
              <router-link
                class="holding-box fy"
                @click.native="saveTab"
                :to="{
                  name: 'subscribe',
                  params: { id: n.id, status: 3 }
                }">
                <!-- top -->
                <van-cell class="top" :value="n.name">
                  <van-icon slot="right-icon" name="arrow" />
                </van-cell>

                <!-- down -->
                <div class="down">
                  <div class="down-left">
                    <div class="title">收益到期日</div>
                    <div class="num">
                      {{ dateFormat(n.endTime, "YYYY/MM/DD") }}
                    </div>
                  </div>

                  <div class="down-center">
                    <div class="title">累计收益(元)</div>
                    <div class="num future">
                      {{ numFormat(n.returnAmount) }}
                    </div>
                  </div>

                  <div class="down-right">
                    <div class="title">认购总额(元)</div>
                    <div class="num">{{ numFormat(n.amount) }}</div>
                  </div>
                </div>
              </router-link>
            </div>
            <!-- 无数据，显示空 -->
            <van-empty
              description="暂无记录"
              v-if="clearedList.isEmpty && !clearedList.loading">
              <van-button
                round
                type="danger"
                class="bottom-button"
                @click="investClick"
                >立即投资</van-button
              >
            </van-empty>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <!-- ------------------------new end  ------------------------ -->
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Row,
  Col,
  List,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup,
  Empty,
  Icon
} from "vant"
import * as PayApi from "@/api/pay"
import session from "@/utils/session"
import moment from "moment"
export default {
  name: "index",
  data: () => ({
    readyFooter: "已经到底了",
    tab: {
      active: "applying"
    },
    applyingList: {
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      data: [],
      isEmpty: false,
      finishedText: ""
    },
    possessionList: {
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      data: [],
      isEmpty: false,
      finishedText: ""
    },
    clearedList: {
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      data: [],
      isEmpty: false,
      finishedText: ""
    },
    statusText: {
      0: "待收款",
      1: "已收款",
      3: "待收款",
      4: "待收款"
    }
  }),
  beforeMount() {
    this.onLoadApplying()
    this.onLoadPossession()
    this.onLoadCleared()
    if (session.get("invest-record-tab")) {
      this.tab.active = session.get("invest-record-tab")
      session.del("invest-record-tab")
    }
  },
  methods: {
    //  onTabClick(name) {
    //    if (name === 'applying') {
    //      this.onLoadApplying()
    //    } else if (name === 'possession') {
    //      this.onLoadPossession()
    //    } else {
    //      this.onLoadCleared()
    //    }
    //  },
    onLoadApplying() {
      this.applyingList.loading = true
      PayApi.listinvest(2, this.applyingList.pageNo, this.applyingList.pageSize)
        .then((data) => {
          this.applyingList.data = this.applyingList.data.concat(data)
          this.applyingList.loading = false
          if (data.length < this.applyingList.pageSize) {
            this.applyingList.finished = true
          } else {
            this.applyingList.pageNo++
          }
          // 判断 data.list 是否为空
          if (this.applyingList.data.length === 0) {
            this.applyingList.isEmpty = true
          } else {
            this.applyingList.isEmpty = false
          }
        })
        .catch((e) => {
          this.applyingList.loading = false
          this.applyingList.finished = true
        })
    },

    onLoadPossession() {
      this.possessionList.loading = true
      PayApi.listinvest(
        1,
        this.possessionList.pageNo,
        this.possessionList.pageSize
      )
        .then((data) => {
          this.possessionList.data = this.possessionList.data.concat(data)
          this.possessionList.loading = false
          if (data.length < this.possessionList.pageSize) {
            this.possessionList.finished = true
          } else {
            this.possessionList.pageNo++
          }

          // 判断 data.list 是否为空
          if (this.possessionList.data.length === 0) {
            this.possessionList.isEmpty = true
          } else {
            this.possessionList.isEmpty = false
          }
        })
        .catch((e) => {
          this.possessionList.loading = false
          this.possessionList.finished = true
          console.info(e)
        })
    },

    onLoadCleared() {
      this.clearedList.loading = true
      PayApi.listinvest(3, this.clearedList.pageNo, this.clearedList.pageSize)
        .then((data) => {
          this.clearedList.data = this.clearedList.data.concat(data)
          this.clearedList.loading = false
          if (data.length < this.clearedList.pageSize) {
            this.clearedList.finished = true
          } else {
            this.clearedList.pageNo++
          }
          console.info(this.clearedList.data.length)
          if (this.clearedList.data.length === 0) {
            this.clearedList.isEmpty = true
          } else {
            this.clearedList.isEmpty = false
          }
        })
        .catch((e) => {
          this.clearedList.finished = true
          this.clearedList.loading = false
        })
    },
    // 立即投资
    investClick() {
      this.$router.push("/invest")
    },
    saveTab() {
      session.set("invest-record-tab", this.tab.active)
    }
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]: List,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Empty.name]: Empty,
    [Icon.name]: Icon
  }
}
</script>

<style lang="less" scoped>
// 2
// tab start----------------------------------------------
::v-deep .van-tabs__line {
  position: absolute;
  bottom: 20px;
  left: 0;
  z-index: 1;
  height: 0.05rem;
  width: 30px !important;
  background-color: #fc6524;
  border-radius: 0.08rem;
}
::v-deep .van-tab {
  color: #999;
}
::v-deep .van-tab--active {
  color: #333333;
}
::v-deep .van-tab__text {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  // background: rgba(255, 255, 255, 0.6);
}

::v-deep .van-hairline--top-bottom:after {
  border: none;
}

// tab end----------------------------------------------

// 3
// 列表 statr---------------------------------------------

// holding
.holding {
  margin: 10px 13px;

  .holding-box {
    border-radius: 6px;
    padding: 14px 13px;
    background-color: #fff;
    display: block;
    // top
    .top {
      font-size: 16px;
      font-weight: 700;
      border-bottom: 1px dashed #ebeaea;
      padding-left: 0;
      .van-icon {
        margin: auto;
      }
    }
    // down
    .down {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;

      // border: 1px solid #000000;
      .down-left {
        text-align: left;
      }
      .down-center {
        text-align: center;
      }
      .down-right {
        text-align: right;
      }
      .title {
        color: #666666;
      }
      .num {
        margin-top: 22px;

        color: #666666;
        font-weight: 700;
      }
      .future {
        color: #fc6524;
      }
    }
    // .center {
    //   margin-top: 15px;
    //   display: flex;
    //   justify-content: space-between;
    //   border: 1px solid #000000;

    //   span {
    //     font-size: 14px;
    //     color: #666666;
    //     // border: 1px solid #000000;
    //   }
    // }
    // // d
    // .down {
    //   margin-top: 22px;
    //   display: flex;
    //   justify-content: space-between;
    //   border: 1px solid #000000;
    // }
  }
}
// 列表 end---------------------------------------------

.row-2 {
  align-items: center;
  color: @gray-dark;
}

.applying,
.cleared {
  .row-3 {
    border-top: 1px solid @gray-light;
  }
  .van-cell {
    padding: 0 0 10px 0;
  }
  .van-cell__title {
    color: @gray-dark;
  }
  .van-cell__value {
    color: @dark;
  }
  .rate .van-cell__value {
    color: @red;
  }
}
.instalments {
  table {
    width: 100%;
    td,
    tr {
      line-height: 0.64rem;
      padding: 5px 0;
    }
  }
}

.card {
  background-color: #fff;
}

// ----------------------
.bottom-button {
  width: 160px;
  height: 40px;
  background-color: #fc6524;
  border: none;
}
</style>
